<mat-toolbar class="overflow-auto">
  <mat-icon mat-list-icon class="me-2">{{icon}}</mat-icon>
  <span class="container-fluid">
    <h1>{{title}}</h1>
  </span>
</mat-toolbar>
